import 'moment-timezone';
import * as moment from 'moment';
// import Moment from 'react-moment';
import { LicenseManager } from 'ag-grid-enterprise';
import * as fetchService from './fetch';
import { getBasePath } from './get-base-path';
import { handleError } from './error-handlers';

export const getEnvironment = () => {

    const domain = window.location.hostname;

    const envMapper = {
        'atp.tal.deere.com': 'TAL',
        'atp-devl.deere.com': 'TAL',
        'atpqual.tal.deere.com': 'QUAL',
        'atp-qual.deere.com': 'QUAL',
        'atp-qual.om-comar-apps-devl-vpn.us.e26.c01.johndeerecloud.com': 'QUAL',
        'atp.deere.com': 'PROD',
        'atp-prod.deere.com': 'PROD',
        localhost: 'LOCAL'
    };

    return envMapper[domain] ? envMapper[domain] : envMapper.localhost;

};

export function stringToArray ( propertyValue ) {

    const updatedpropertyValue = propertyValue.replace( /\n/g, ',' ),
        convertedArray = updatedpropertyValue.split( ',' );

    convertedArray.forEach( ( element, index ) => {

        convertedArray[index] = element.trim();

    } );
    return convertedArray;

}

export function convertUnixtodate ( givenDate ) {

    if ( givenDate && givenDate !== '' && givenDate !== 0 ) {

        return moment( givenDate * 1000 ).utc().format( 'MM/DD/YYYY' );

    }
    return '';

}

export function dateFromUTCToLocal ( givenDate ) {

    if ( !givenDate ) return givenDate;

    const date = moment( givenDate );
    if ( date && date.utcOffset() ) {

        date.subtract( date.utcOffset(), 'minutes' ).utc();

    } else {

        return givenDate;

    }
    return date.toDate();

}

export function dateFromLocalToUTC ( givenDate ) {

    if ( !givenDate ) return givenDate;

    const date = moment( givenDate );
    if ( date && date.utcOffset() ) {

        date.add( date.utcOffset(), 'minutes' ).utc();

    } else {

        return givenDate;

    }
    return date.toDate();

}

export function getFieldValue ( val ) {

    if ( val !== undefined && val !== '' && typeof ( val ) === 'string' ) {

        const splitVal = val.split( ' - ' );
        if ( splitVal.length > 1 ) {

            if ( ( splitVal[0] === undefined || splitVal[0] === 'undefined' )
                && ( splitVal[1] === undefined || splitVal[1] === 'undefined' ) ) return '';
            if ( ( splitVal[0] === undefined || splitVal[0] === '' )
                && splitVal[1] !== undefined ) return splitVal[1];
            if ( splitVal[0] !== undefined &&
                ( splitVal[1] === undefined || splitVal[1] === '' ) ) return splitVal[0];
            return val;

        }
        return val;

    } return val === undefined ? '' : val;

}

export function filterEmpty ( entries ) {

    const arr = stringToArray( entries );
    const cleanArr = arr.filter( el => el !== null && el.trim() !== '' );
    cleanArr.forEach( ( element, index ) => {

        cleanArr[index] = element.trim();

    } );
    return cleanArr;

}

export function isAlphanumeric ( value, allowEmpty = false ) {

    let desired = true;
    let format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

    if ( typeof value !== 'object' && value !== undefined ) {

        if ( allowEmpty ) format = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

        desired = !( format.test( value ) );

    }
    return desired;

}

export function formatGivenDate ( givenDate, formatType ) {

    if ( givenDate && givenDate !== '' && givenDate !== 0 ) {

        if ( givenDate < 0 ) return moment( givenDate + ( 48 * 3600 * 1000 ) ).tz( 'CST6CDT' ).format( formatType );
        return moment( givenDate ).tz( 'CST6CDT' ).format( formatType );

    }
    return '';

}

export function formatLocalDate ( givenDate, formatType ) {

    if ( givenDate && givenDate !== '' && givenDate !== 0 ) {

        return moment( givenDate ).format( formatType );

    }
    return '';

}

export async function getExcelDownloadFile ( response, fileName ) {

    response.blob().then( blob => {

        const url = window.URL.createObjectURL( blob );
        const a = document.createElement( 'a' );
        a.href = url;
        a.download = fileName;
        a.click();

    } );

}

export async function setAgGridLicense ( ) {

    const basePath = getBasePath();
    const endPoint = `${basePath}/ag-grid-license`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );
        
        if ( !response.ok ) {

            return handleError( response );

        }

        const licenseKey = await response.text();
        
        if ( licenseKey ) {

            LicenseManager.setLicenseKey( licenseKey );

        }

    } catch ( error ) {

        console.error( 'Error fetching AG Grid license:', error );
        return handleError( error );

    }

}
